import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { createNewCategory, updateCategory } from "./service/category.service";
import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { addList, setCategory, updateList } from "../../Category/redux/actions";

const CreateNewCategory = () => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector(
    (state) => state.categoryReducer.selectCategory
  );

  const [formData, setFormData] = useState({
    categoryNameSI: {
      key: "categoryNameSI",
      label: "Category name (SI)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    categoryNameEN: {
      key: "categoryNameEN",
      label: "Category name (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateCategoryForm = {
      ...formData,
    };

    updateCategoryForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateCategoryForm[inputIdentity].value,
      updateCategoryForm[inputIdentity].validation
    );

    if (validityRes) {
      updateCategoryForm[inputIdentity].isValid = validityRes.isValid;
      updateCategoryForm[inputIdentity].invalidReason = validityRes.reason;
      updateCategoryForm[inputIdentity].value = event;
      updateCategoryForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateCategoryForm) {
        formIsValid = updateCategoryForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateCategoryForm);
    }
  };

  const clearAll = () => {
    const updateCategoryForm = {
      ...formData,
    };
    for (let key in updateCategoryForm) {
      console.log(updateCategoryForm[key]);
      updateCategoryForm[key].value = "";
      updateCategoryForm[key].isValid = false;
      updateCategoryForm[key].touched = false;
    }
    setFormData(updateCategoryForm);
  };

  useEffect(() => {
    if (selectedCategory?.category_id) {
      console.log("id", selectedCategory?.category_id);
      const updateCategoryForm = {
        ...formData,
      };

      updateCategoryForm.categoryNameSI.value = selectedCategory?.name?.si;
      updateCategoryForm.categoryNameEN.value = selectedCategory?.name?.en;
      setFormData(updateCategoryForm);
    } else {
      for (let key in updateCategoryForm) {
        console.log(updateCategoryForm[key]);
        updateCategoryForm[key].value = "";
        updateCategoryForm[key].isValid = false;
        updateCategoryForm[key].touched = false;
      }
      setFormData(updateCategoryForm);
    }
  }, [selectedCategory]);

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateCategoryForm = {
      ...formData,
    };

    if (selectedCategory?.category_id) {
      console.log("selectedCategory", selectedCategory?.category_id);
      try {
        const result = await updateCategory(
          {
            name: {
              si: updateCategoryForm.categoryNameSI.value,
              en: updateCategoryForm.categoryNameEN.value,
            },
            status: "new",
          },
          selectedCategory?.category_id
        );
        console.log("Updated Category===", result);

        if (result.data) {
          dispatch(updateList(result?.data));
          // dispatch(setCategory(result?.data));
          Store.addNotification({
            title: "Success!",
            message: "Category Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      } catch (error) {
        Store.addNotification({
          title: "Error!",
          message: "Category Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
      }
    } else {
      const response = await createNewCategory({
        name: {
          si: updateCategoryForm.categoryNameSI.value,
          en: updateCategoryForm.categoryNameEN.value,
        },
        status: "new",
      });
      console.log("category details ===", response);
      try {
        if (response.data) {
          dispatch(addList(response?.data));
          // dispatch(setCategory(response?.data));
          Store.addNotification({
            title: "Success!",
            message: "Category Create Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      } catch (error) {
        Store.addNotification({
          title: "Error!",
          message: "Category Create Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
      }
    }
  };

  const updateCategoryForm = { ...formData };

  return (
    <>
      <div className="hne-create-category-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Category",
            size: "md-md",
          }}
        />

        <InputBox
          data={updateCategoryForm.categoryNameSI}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(
              e.target.value,
              updateCategoryForm.categoryNameSI.key
            );
          }}
        />
        <InputBox
          data={updateCategoryForm.categoryNameEN}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(
              e.target.value,
              updateCategoryForm.categoryNameEN.key
            );
          }}
        />

        <Button
          data={{
            btnName: "Done",
            // buttonType: selectedCategory?.category_id ? "Update" : "primary",
            buttonType:
              updateCategoryForm.categoryNameSI.value === "" ||
              updateCategoryForm.categoryNameEN.value === ""
                ? "primary disabled"
                : "primary",
            buttonSize: "lg",
            isLoading: isLoading,
          }}
          onClick={async (e) => {
            e.preventDefault();
            await onClickSave(e);
          }}
        />
      </div>
    </>
  );
};
export default withRouter(CreateNewCategory);
